import { render } from "./MemberCardConfigs.vue?vue&type=template&id=1d5a54c8"
import script from "./MemberCardConfigs.vue?vue&type=script&lang=js"
export * from "./MemberCardConfigs.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__